import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from "react-router-dom";
import DefaultLayout from '../layout/DefaultLayout';
import CallbackPage from "../authentication/callback.components";
import AccessDenied from '../components/toolbar.component/accessDenied';
import ErrorComponent from '../components/shared/errorComponent';

const CustomerGrid = lazy(() => import('../components/Customers'));
const AllCards = lazy(() => import('../components/cards/index'));
const CardAction = lazy(() => import("src/components/cards/cardAction"));
const Roles = lazy(() => import("src/components/settings/Roles"));
const RolesDetails = lazy(() => import("src/components/settings/Roles/rolesDetails"));
const Settings = lazy(() => import("src/components/settings"));
const Configuration = lazy(() => import("src/components/settings/Configuration"));
const AddUser = lazy(() => import("src/components/settings/users/add"));
const UserInfo = lazy(() => import('src/components/settings/users/index'));
const CustomerInfo = lazy(() => import("src/components/Customers/customDetails"));
const Payees = lazy(() => import("src/components/payees"));
const CustomerPayees = lazy(() => import('src/components/Customers/customDetails/payees'));
const Transactions = lazy(() => import("src/components/transactions"));
const ImportExcel = lazy(() => import("src/components/importExcel"));
const ReportDetails = lazy(() => import("src/components/Reports"));
const AuditLogs = lazy(() => import("src/components/auditLogs"));
const WalletGrid = lazy(() => import("src/components/Customers/customDetails/wallets"));
const TransactionGrid = lazy(() => import("src/components/Customers/customDetails/transactions"));
const Commissions = lazy(() => import("src/components/commissions"));
const Commission = lazy(() => import("src/components/commissions/commission"))
const CommissionsTier = lazy(() => import("src/components/commissions/commissionsTier"));
const Banks = lazy(() => import("src/components/settings/banks"));
const Bank = lazy(() => import("src/components/settings/banks/bank"))
const Profile = lazy(() => import("src/components/userProfile/profile"));
const UserProfile = lazy(() => import("src/components/userProfile/userProfile"));
const Security = lazy(() => import("src/components/userProfile/security"));
const KYC = lazy(() => import("src/components/Customers/customDetails/kycdetails"));
const CustomerCards = lazy(() => import("src/components/customerCards"));
const CardDetailsView = lazy(() => import("src/components/cards/cardDetailsView"));
const ComingSoon = lazy(() => import("src/components/commingSoon"));
const ReferralsData = lazy(() => import("src/components/Customers/referrals"));
const BankAccounts = lazy(() => import("src/components/bankAccounts/index"));
const Exchange = lazy(() => import("src/components/exchange"));
const Payments = lazy(() => import("src/components/payments"));
const AllNotes = lazy(() => import("src/components/settings/notes"))
const CreateNotes = lazy(() => import("src/components/settings/notes/createNote"))
const Tokens = lazy(() => import("src/components/settings/tokens"))
const FeeDetails = lazy(() => import("src/components/Customers/customDetails/feeDetails"))
const  CreateCase = lazy(()=>import('src/components/Customers/cases/addform'))
const Cases = lazy(()=>import('src/components/cases'))
const ViewCases = lazy(()=>import('src/components/cases/casesView'))
const Edit = lazy(()=>import('src/components/cases/case/edit'))
const NoticeView = lazy(()=>import("src/components/settings/notes/noteView"));
import Dashboard from 'src/components/dashboard';
import Cards from 'src/components/Customers/customDetails/cards';
import { Spin } from 'antd';
import ExchangeDetails from 'src/components/Customers/customDetails/exchange';
import BankDetails from 'src/components/Customers/customDetails/bank';
import PaymentsDetails from 'src/components/Customers/customDetails/payments';
import AddressDetails from 'src/components/Customers/customDetails/customerIfo';
import PersonalDetailView from 'src/components/Customers/customDetails/customerinfoview';
const SubscriptionData =lazy(() => import('src/components/subscriptions'));
const CardsDetailsView = lazy(() => import("src/components/Customers/customDetails/cards/cardDetailVeiw"))
const AppRouter = () => {
  return createBrowserRouter([
    {
      path: "/",
      element: <DefaultLayout />,
      children: [
        {
          path: 'dashboard',
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Dashboard />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "customers",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <CustomerGrid />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "payees",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Payees />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "customer",
          errorElement: <ErrorComponent />,
          children: [
            {
              path: ":custId?/:tabName?",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <CustomerInfo />
                </Suspense>
              ),
              errorElement: <ErrorComponent />,
              children: [
                {
                  path: 'Wallets',
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <WalletGrid />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: 'Exchange',
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <ExchangeDetails/>
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },
                {
                  path: 'Bank',
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                    <BankDetails/>
                  
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },
                
                {
                  path: 'Cards',
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <Cards />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },

                {
                  path: 'Payments',
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                   <PaymentsDetails/>
                  
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },
                



                {
                  path: "cardDetails/:cardId",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <CardsDetailsView/>
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },
                {
                  path: "Transactions",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <TransactionGrid />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "payees",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <CustomerPayees />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "Kyc/Kyb",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <KYC />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "Referral",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <ReferralsData />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "Personal Information",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <AddressDetails />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "personalInfo/:personalDetailId",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <PersonalDetailView /></Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "Fee",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <FeeDetails />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                },
                {
                  path: "accessdenied",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <AccessDenied />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />
                }
              ]
            },
          ]
        },
        {
          path: "settings",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Settings />
            </Suspense>
          ),
          errorElement: <ErrorComponent />,
          children: [
            {
              path: "roles",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <Roles />
                </Suspense>
              ),
              errorElement: <ErrorComponent />,
            },
            {
              path: "roles/:id/:roleName?/:type?",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <RolesDetails />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "users",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <UserInfo />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "users/:id/:userName/:type",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <AddUser />
                </Suspense>
              ),
              errorElement: <ErrorComponent />,
            },
            {
              path: "configuration",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <Configuration />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "cardsSetup",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <AllCards />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "cardsSetup/view/:id",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <CardDetailsView mode={'View'} />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "cardsSetup/:mode/:id",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <CardAction />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "auditlogs",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <AuditLogs />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "notes",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <AllNotes />
                </Suspense>
              ),
              errorElement: <ErrorComponent />,
            },
            {
              path: 'notes/:mode/:id',
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <CreateNotes />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "notes/view/:id",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <NoticeView />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "products",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <ComingSoon />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },

            {
              path: "commissions",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <Commissions />
                </Suspense>
              ),
              errorElement: <ErrorComponent />,
              children: [
                {
                  path: "commission/:id/:tier/:screen",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <Commission />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },
                {
                  path: "tier/:id/:templateName?/:type?",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <CommissionsTier />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                },
              ]
            },
            {
              path: "banks",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <Banks />
                </Suspense>
              ),
              errorElement: <ErrorComponent />,
              children: [
                {
                  path: "bank/:id/:name/:screen",
                  element: (
                    <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                      <Bank />
                    </Suspense>
                  ),
                  errorElement: <ErrorComponent />,
                }
              ]
            },
            {
              path: "tokens",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <Tokens />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            }
          ]
        },

        {
          path: "reports",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <ReportDetails />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "userprofile",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Profile />
            </Suspense>
          ),
          errorElement: <ErrorComponent />,
          children: [
            {
              path: "profile",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <UserProfile />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
            {
              path: "security",
              element: (
                <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
                  <Security />
                </Suspense>
              ),
              errorElement: <ErrorComponent />
            },
          ]
        },
        {
          path: "bankAccounts",
          element: (

            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <BankAccounts />,
            </Suspense>

          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "transactions",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Transactions />
            </Suspense>
          ),
          errorElement: <ErrorComponent />,
        },
        {
          path: "cards",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <CustomerCards />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "exchange",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Exchange />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: 'payments',
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Payments />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "callback",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <CallbackPage />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: "import-excel",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <ImportExcel />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },
        {
          path: 'accessdenied',
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <AccessDenied />
            </Suspense>
          ),
          errorElement: <>Something went wrong</>,
        },
        {
          path:'/customers/:id/creatcase',
          element:
          ( <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
          <CreateCase />
          </Suspense>),
          errorElement:<ErrorComponent/>
        },
        {
          path:'/payees/:id/createcase',
          element:( <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
            <CreateCase />
            </Suspense>),
          errorElement:<ErrorComponent/>
        },
        {
          path:'/transaction/:id/createcase',
          element:( <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
            <CreateCase />
            </Suspense>),
          errorElement:<ErrorComponent/>
 
        },
        {
          path:'cases',
          element:(
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Cases/>
              </Suspense>
          ),errorElement:<ErrorComponent/>,
        },
        {
          path: 'cases',
          element: <ViewCases />
        },
        {
          path:`edit/:id/:screen?/:caseState?`,
          element:(
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <Edit/>
              </Suspense>
          )
        },
        {
          path:`caseView/:id/:caseState?`,
          element:(
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <ViewCases/>
              </Suspense>
          )
        },
        {
          path: "subscriptions",
          element: (
            <Suspense fallback={<div className='text-center'>  <Spin size="large" /></div>}>
              <SubscriptionData />
            </Suspense>
          ),
          errorElement: <ErrorComponent />
        },

      ]
    }
  ]);
};
export default AppRouter;